
<div *ngIf="showSelect" style="width:100%;height:100%;position:fixed;top:0;left:0;z-index:99;background-color: #00000055;border:solid 3px yellow;" (click)="toggleShowSelect()"></div>
<div *ngIf="showPicker" style="width:100%;height:100%;position:fixed;top:0;left:0;z-index:99;background-color: #00000055;border:solid 3px yellow;" (click)="toggleShowPicker()"></div>

<!--Entity visualizer / visual controller -->
<div mat-dialog-title>
	<fa-icon icon="times" (click)="onCancelClick()" class="fdm-icon float-right" style="cursor:pointer;color:#555;margin-top:-20px;margin-right:-14px;"></fa-icon>
	{{ data.title | translate }} <span style="display:inline-block;padding:3px 15px;border-radius:4px;background-color:rgb(231, 231, 231);color:#333;margin-left:3px;">{{ (plugin?.meta?.translator + "." + property) | translate }}</span>

    <!-- <span *ngIf="showPicker" id="color-picker" style="position:fixed;display:block;border:solid 1px #abc;margin-bottom:15px;width:500px;height:300px;z-index:9999;padding:20px;background-color:#fff;">
        <div class="colors fdm-linked" style="height:30px;width:100%;display:inline-block;" (click)="toggleShowSelect()">
            <fa-icon icon="chevron-down" style="float: right;color: #fff;margin-right: 10px;margin-top: 5px;"></fa-icon>
            <div *ngIf="section.value == 'none'" class="fdm-color-band-label">-- {{ 'GENERIC.NONE' | translate }} --</div>
            <div *ngIf="section.value !== 'none'" [style.background]="plugin.linearScale(section.value)" class="fdm-color-band-label">{{ 'COLORS.MODELS.'+section.value.toUpperCase() | translate }}</div>
        </div>
        <mat-slider color="primary" style="width:100%;"
            class="fdm-layer-slider" [min]="0" [max]="500" [step]="1"
            [(ngModel)]="pickColor" (change)="picked($event.value,section)" (input)="picking($event.value,section);"
        ></mat-slider>
        <div *ngIf="showSelect" class="fdm-select-open" style="top:30px;width:300px;position:absolute;height:auto;min-height:100px;z-index:999;background-color:#fff;padding:1px 2px; border: solid 3px #e0bb1c; box-shadow: 0 0 280px 10px #223;">
            <div class="fdm-select-list fdm-linked" *ngFor="let aa of section.options" [class.fdm-color-band-label]="section.optionType && section.optionType == 'colors'">
                <ng-container *ngIf="!section.optionType">
                    <span (click)="toggleShowSelect(aa,section)">{{ aa | translate }}</span>
                </ng-container>
                <ng-container *ngIf="section.optionType && section.optionType == 'colors'">
                    <div *ngIf="aa == 'none'" class="fdm-color-band-label" (click)="toggleShowSelect(aa,section)">-- {{ 'GENERIC.NONE' | translate }} --</div>
                    <div *ngIf="aa !== 'none'" [style.background]="plugin.linearScale(aa)" class="fdm-color-band-label" (click)="toggleShowSelect(aa,section)">{{ 'COLORS.MODELS.'+aa.toUpperCase() | translate }}</div>
                </ng-container>
            </div>
        </div>
    </span> -->
</div>

<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>
<div mat-dialog-content>
    <div style="text-align:right;">
        <span *ngIf="showColors" class="fdm-linked" (click)="toggleShowColors()">{{'PLUGINS.COLORIZER.PICK' | translate }} <fa-icon icon="chevron-up"></fa-icon></span>
        <span *ngIf="!showColors" class="fdm-linked" (click)="toggleShowColors()">{{'PLUGINS.COLORIZER.PICK' | translate }} <fa-icon icon="chevron-down"></fa-icon></span>
        <div *ngIf="showColors" style="margin:10px 0;text-align:right;">
            <span style="border:solid 1px #abc;margin-bottom:15px;">
                <div class="colors fdm-linked" style="height:30px;width:400px;display:inline-block;" (click)="toggleShowSelect()">
                    <fa-icon icon="chevron-down" style="float: right;color: #fff;margin-right: 10px;margin-top: 5px;"></fa-icon>
                    <div *ngIf="section.value == 'none'" class="fdm-color-band-label">-- {{ 'GENERIC.NONE' | translate }} --</div>
                    <div *ngIf="section.value !== 'none'" [style.background]="plugin.linearScale(section.value)" class="fdm-color-band-label">{{ 'COLORS.MODELS.'+section.value.toUpperCase() | translate }}</div>
                </div>
                <div *ngIf="showSelect" class="fdm-select-open" style="top:30px;width:300px;position:absolute;height:auto;min-height:100px;z-index:999;background-color:#fff;padding:1px 2px; border: solid 3px #e0bb1c; box-shadow: 0 0 280px 10px #223;">
                    <div class="fdm-select-list fdm-linked" *ngFor="let aa of section.options" [class.fdm-color-band-label]="section.optionType && section.optionType == 'colors'">
                        <ng-container *ngIf="!section.optionType">
                            <span (click)="toggleShowSelect(aa,section)">{{ aa | translate }}</span>
                        </ng-container>
                        <ng-container *ngIf="section.optionType && section.optionType == 'colors'">
                            <div *ngIf="aa == 'none'" class="fdm-color-band-label" (click)="toggleShowSelect(aa,section)">-- {{ 'GENERIC.NONE' | translate }} --</div>
                            <div *ngIf="aa !== 'none'" [style.background]="plugin.linearScale(aa)" class="fdm-color-band-label" (click)="toggleShowSelect(aa,section)">{{ 'COLORS.MODELS.'+aa.toUpperCase() | translate }}</div>
                        </ng-container>
                    </div>
                </div>
            </span>

            <div class="clearfix"></div>

            <!-- <button class="fdm-button" mat-flat-button color="primary" style="color:#fff;height:25px;margin:15px 0 15px 10px;" (click)="pick()"> 
                <fa-icon icon="eye-dropper"></fa-icon> &nbsp;Pick a color
            </button> -->

            <button class="fdm-button" mat-flat-button color="primary" style="color:#fff;height:25px;margin:15px 0 15px 10px;" (click)="colorize()"> 
                <fa-icon icon="stream"></fa-icon> &nbsp;{{ 'PLUGINS.COLORIZER.ALL' | translate}} 
            </button>
        </div>
    </div>
    <div class="fdm-big-choice-box fdm-buttons" style="margin-top:15px;overflow-y:hidden;">
        <table class="fdm-sidebar-table-list" style="width:100%;" *ngIf="map">
            <tr>
                <th style="height:40px;background-color:rgb(228, 243, 255)">
                    {{ 'PLUGINS.COLORIZER.VALUE' | translate }}
                    <!-- <mat-select style="color:#bbb;font-size: 12px;height:15px;" [(ngModel)]="sortingByType" (selectionChange)="sortByType($event)">
                        <mat-option *ngFor="let sort of sortTypeOptions" [value]="sort">{{sort | translate }}</mat-option>
                    </mat-select>
                    <mat-select style="color:#bbb;font-size: 12px;height:15px;" [(ngModel)]="sortingByOrder" (selectionChange)="sortByOrder($event)">
                        <mat-option *ngFor="let sort of sortOrderOptions" [value]="sort">{{sort | translate }}</mat-option>
                    </mat-select> -->
                </th>
                <th style="height:40px;background-color:rgb(228, 243, 255)">
                    {{ 'PLUGINS.COLORIZER.COLOR' | translate }}
                </th>
            </tr>
            <tr *ngFor="let p of map | keyvalue: originalOrder; let idx = index;">
                <td class="fdm-table-title">{{ p.key }} <span style="float:right;">=</span></td>
                <td class="fdm-table-tools">
                    <div class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" 
                        [(colorPicker)]="p.value.color" 
                        [style.background]="p.value.color"
                        cpOutputFormat="rgba"
                        cpPosition="bottom"
                        cpPositionOffset="50%"
                        [cpPositionRelativeToArrow]="true">
                        <fa-icon icon="chevron-down" ></fa-icon>
                    </div> <!-- cpOutputFormat="rgba" -->
                    <input type="hidden" [value]="p.value.color" />
                    <!-- <fa-icon class="fdm-linked" icon="eye-dropper" (click)="pick(idx,p.value)"></fa-icon> -->

                </td>
            </tr>
        </table>
    </div>
</div>
<div mat-dialog-actions class="align-content-right">
    <button *ngIf="data.negBtn" color="primary" mat-raised-button (click)="onCancelClick()"> {{ 'GENERIC.CANCEL' | translate }}</button>
    <button color="accent" mat-raised-button (click)="onSaveClick()" >{{ 'GENERIC.SAVE' | translate }}</button>
</div>
